import React from "react";
import EmployeeSheetTable from "../../components/ui-custom/EmployeeSheetTable";

const OrderBookings = () => (
  <div>
    <h2 className="font-display font-semibold text-2xl text-foreground mb-6">Order Bookings</h2>
    <EmployeeSheetTable
      endpoint="/employees/orders"
      emptyLabel="No order bookings have been added to the tracking sheet yet."
    />
  </div>
);

export default OrderBookings;
